<template>
  <router-link :to="{ name: 'live.show', params: { id: live.id, slug: live.slug } }" class="live-schedule-thumb-box">
    <BoxShadow>
      <div class="thumb-box">
        <img :src="live.thumb_url" :alt="live.name" class="w-100">

        <!-- <span class="live-tag"><span>Live agendada</span></span> -->
      </div>
      <div class="live-info">
        <header class="content-spacing">
          <h6>{{ live.name }}</h6>
          <p v-if="live.user">por <b>{{ live.user.name }}</b></p>
        </header>

        <div class="text-center divisor-box">
          <ContentDivisor />
        </div>

        <div class="date-box">
          <div class="date">{{ dateFormat }}</div>
          <div class="time"><small>{{ timeFormat }}</small></div>
        </div>
      </div>
    </BoxShadow>
  </router-link>
</template>

<script>
import 'moment/locale/pt'
import moment from 'moment'
import BoxShadow from '@/components/boxes/BoxShadow'
import ContentDivisor from '@/components/layout/ContentDivisor'
import { computed } from '@vue/composition-api'

export default {
  components: {
    BoxShadow,
    ContentDivisor
  },
  props: {
    live: { type: Object, required: true }
  },
  setup(props) {
    const live = computed(() => props.live)

    const dateFormat = computed(() => {
      return moment(live.value.released_at).format('D [de] MMMM')
      // .toUpperCase()
    })

    const timeFormat = computed(() => {
      return moment(live.value.released_at).format('[às] H:mm[hrs]')
    })

    return {
      dateFormat,
      timeFormat
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/sass/variables";

.live-schedule-thumb-box {
  display: block;
  position: relative;
  // width: 290px;

  .live-info {
    padding: 16px;
  }

  .divisor-box {
    margin-bottom: 16px;
  }

  .date-box {
    text-align: center;
  }

  .thumb-box {
    position: relative;

    .live-tag {
      display: inline-flex;
      position: absolute;
      bottom: -13.5px;
      border: 2px solid #fff;
      left: 50%;
      transform: translateX(-50%);
      align-items: center;
      justify-content: center;
      background: #f00;
      color: #fff;
      border-radius: 30px;
      font-size: 13px;
      padding: 2px 10px;
      width: 150px;
      font-weight: 600;
      z-index: 5;

      span {
        flex-shrink: 0;
      }

      &:before {
        content: '';
        width: 6px;
        height: 6px;
        background: #fff;
        border-radius: 100%;
        margin-right: 8px;
        animation: blink 2s infinite;
        transition: .5s all;
        flex-shrink: 0;
      }
    }
  }
}

@keyframes blink {
  0% {
    opacity: 1
  }

  33% {
    opacity: 1
  }

  66% {
    opacity: 0
  }

  100% {
    opacity: 1
  }
}</style>